import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import { setAssessedBy, setDateTime } from '../../procedures/labs/store/labs.actions'
import { IVitalOptionsState } from '../../options/store/options.types'
import { getVitalOptionsSelector } from '../../options/selectors'

export function* setLabsQuickAction() {
  const userId: string = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate } = props
  yield put(setDateTime(savedTimeString, currentDate))
  yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
}

export function* setLabsQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_LABS_BUTTON_TYPE], setLabsQuickAction)
}
